// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const stufful: PokeData = {
  "id": 759,
  "name": "stufful",
  "height": 5,
  "weight": 68,
  "base_experience": 68,
  "types": [
    PokeType.NORMAL,
    PokeType.FIGHTING
  ],
  "api_moves": [
    "tackle",
    "take-down",
    "thrash",
    "double-edge",
    "leer",
    "strength",
    "bide",
    "flail",
    "endure",
    "pain-split",
    "superpower",
    "hammer-arm",
    "payback",
    "baby-doll-eyes",
    "brutal-swing"
  ],
  "moves": [
    "tackle",
    "leer",
    "superpower",
    "supersonic",
    "rolling-kick",
    "scary-face",
    "bulk-up",
    "purification",
    "coaching",
    "refresh",
    "headbutt",
    "quick-attack",
    "tri-attack"
  ],
  "evolution_chain": {
    "id": 391,
    "item": null,
    "species": [
      {
        "name": "stufful",
        "order": 759,
        "types": [
          PokeType.NORMAL,
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "bewear",
        "order": 760,
        "types": [
          PokeType.NORMAL,
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": 759,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 27,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 60,
    "speed": 50,
    "ability_power": 75
  },
  "stat_changes": [],
  "catch_rate": 140,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
